import { SidenavComponents } from '../../item-configs/item-configs';
import { ThemePicker } from './ThemePicker';

export const SidenavComponentsMapping = {
  [SidenavComponents.ThemePickerButton]: ThemePicker,
};
